/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Flora Database API
 * Plant database management system
 * OpenAPI spec version: 1.0.0
 */
import type {
  DesignPaletteDetail,
  DesignPaletteDetailRequest,
  PaginatedDesignPaletteListList,
  PalettesListParams,
  PatchedDesignPaletteDetailRequest,
} from '../../model'

import { customInstance } from '../../axios-instance'
import type { BodyType } from '../../axios-instance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

export const getPalettes = () => {
  /**
 * ViewSet for managing design palettes.
List returns lightweight data; detail returns plant IDs.
 */
  const palettesList = (
    params?: PalettesListParams,
    options?: SecondParameter<typeof customInstance<PaginatedDesignPaletteListList>>
  ) => {
    return customInstance<PaginatedDesignPaletteListList>(
      { url: `/api/palettes/`, method: 'GET', params },
      options
    )
  }
  /**
 * ViewSet for managing design palettes.
List returns lightweight data; detail returns plant IDs.
 */
  const palettesCreate = (
    designPaletteDetailRequest: BodyType<DesignPaletteDetailRequest>,
    options?: SecondParameter<typeof customInstance<DesignPaletteDetail>>
  ) => {
    return customInstance<DesignPaletteDetail>(
      {
        url: `/api/palettes/`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: designPaletteDetailRequest,
      },
      options
    )
  }
  /**
 * ViewSet for managing design palettes.
List returns lightweight data; detail returns plant IDs.
 */
  const palettesRetrieve = (
    id: number,
    options?: SecondParameter<typeof customInstance<DesignPaletteDetail>>
  ) => {
    return customInstance<DesignPaletteDetail>(
      { url: `/api/palettes/${id}/`, method: 'GET' },
      options
    )
  }
  /**
 * ViewSet for managing design palettes.
List returns lightweight data; detail returns plant IDs.
 */
  const palettesUpdate = (
    id: number,
    designPaletteDetailRequest: BodyType<DesignPaletteDetailRequest>,
    options?: SecondParameter<typeof customInstance<DesignPaletteDetail>>
  ) => {
    return customInstance<DesignPaletteDetail>(
      {
        url: `/api/palettes/${id}/`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: designPaletteDetailRequest,
      },
      options
    )
  }
  /**
 * ViewSet for managing design palettes.
List returns lightweight data; detail returns plant IDs.
 */
  const palettesPartialUpdate = (
    id: number,
    patchedDesignPaletteDetailRequest: BodyType<PatchedDesignPaletteDetailRequest>,
    options?: SecondParameter<typeof customInstance<DesignPaletteDetail>>
  ) => {
    return customInstance<DesignPaletteDetail>(
      {
        url: `/api/palettes/${id}/`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: patchedDesignPaletteDetailRequest,
      },
      options
    )
  }
  /**
 * ViewSet for managing design palettes.
List returns lightweight data; detail returns plant IDs.
 */
  const palettesDestroy = (id: number, options?: SecondParameter<typeof customInstance<void>>) => {
    return customInstance<void>({ url: `/api/palettes/${id}/`, method: 'DELETE' }, options)
  }
  /**
   * Add cultivar plants to a palette (accepts Plant IDs for cultivar-type plants).
   */
  const palettesAddCultivarsCreate = (
    id: number,
    designPaletteDetailRequest: BodyType<DesignPaletteDetailRequest>,
    options?: SecondParameter<typeof customInstance<DesignPaletteDetail>>
  ) => {
    return customInstance<DesignPaletteDetail>(
      {
        url: `/api/palettes/${id}/add-cultivars/`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: designPaletteDetailRequest,
      },
      options
    )
  }
  /**
   * Add plants to a palette without replacing existing ones.
   */
  const palettesAddPlantsCreate = (
    id: number,
    designPaletteDetailRequest: BodyType<DesignPaletteDetailRequest>,
    options?: SecondParameter<typeof customInstance<DesignPaletteDetail>>
  ) => {
    return customInstance<DesignPaletteDetail>(
      {
        url: `/api/palettes/${id}/add-plants/`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: designPaletteDetailRequest,
      },
      options
    )
  }
  /**
   * Remove cultivar plants from a palette.
   */
  const palettesRemoveCultivarsCreate = (
    id: number,
    designPaletteDetailRequest: BodyType<DesignPaletteDetailRequest>,
    options?: SecondParameter<typeof customInstance<DesignPaletteDetail>>
  ) => {
    return customInstance<DesignPaletteDetail>(
      {
        url: `/api/palettes/${id}/remove-cultivars/`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: designPaletteDetailRequest,
      },
      options
    )
  }
  /**
   * Remove plants from a palette.
   */
  const palettesRemovePlantsCreate = (
    id: number,
    designPaletteDetailRequest: BodyType<DesignPaletteDetailRequest>,
    options?: SecondParameter<typeof customInstance<DesignPaletteDetail>>
  ) => {
    return customInstance<DesignPaletteDetail>(
      {
        url: `/api/palettes/${id}/remove-plants/`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: designPaletteDetailRequest,
      },
      options
    )
  }
  return {
    palettesList,
    palettesCreate,
    palettesRetrieve,
    palettesUpdate,
    palettesPartialUpdate,
    palettesDestroy,
    palettesAddCultivarsCreate,
    palettesAddPlantsCreate,
    palettesRemoveCultivarsCreate,
    palettesRemovePlantsCreate,
  }
}
export type PalettesListResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPalettes>['palettesList']>>
>
export type PalettesCreateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPalettes>['palettesCreate']>>
>
export type PalettesRetrieveResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPalettes>['palettesRetrieve']>>
>
export type PalettesUpdateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPalettes>['palettesUpdate']>>
>
export type PalettesPartialUpdateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPalettes>['palettesPartialUpdate']>>
>
export type PalettesDestroyResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPalettes>['palettesDestroy']>>
>
export type PalettesAddCultivarsCreateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPalettes>['palettesAddCultivarsCreate']>>
>
export type PalettesAddPlantsCreateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPalettes>['palettesAddPlantsCreate']>>
>
export type PalettesRemoveCultivarsCreateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPalettes>['palettesRemoveCultivarsCreate']>>
>
export type PalettesRemovePlantsCreateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getPalettes>['palettesRemovePlantsCreate']>>
>
